/*
  Translations module: in the future it should support multiple languages and export the relevant
  language according to the locale of the user
 */

export { default } from './en.json'
